import React from "react";
import { useParams } from "react-router-dom";
import RootPortfolio from "container/portfolio/RootPortfolio";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";

function PortfolioPage(props) {
  const params = useParams();
  const ownerName = params.name.toLowerCase();

  return (
    <AppUpdateCheckpoint>
      <RootPortfolio ownerName={ownerName} />
    </AppUpdateCheckpoint>
  );
}

export default PortfolioPage;
